import { Component, EventListener } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import ajax from '@swisslife/shared-ui/src/utils/ajax/js/ajax';

enum Selectors {
	SearchBoxIcon = '.js-m-search-box__icon',
	GSCSearchButton = '.gsc-search-button',
}

@Component('SearchBox')
export class SearchBox extends GondelJqueryComponent {
	public start() {
		this.initializeSearch();
	}

	public setFocusToInput() {
		this.$ctx.find('input').focus();
	}

	private async initializeSearch() {
		await ajax(`https://cse.google.com/cse.js?cx=${this.$ctx.data('cx-key')}`, {
			dataType: 'script',
		});
		await this.waitForGoogle();
		this.$ctx.find('input').attr('placeholder', this.$ctx.data('placeholder'));
	}

	private waitForGoogle() {
		const check = (cb: () => void) => {
			if (this.$ctx.find('input').length === 1) {
				cb();
				return;
			}
			setTimeout(() => {
				check(cb);
			}, 100);
		};
		return new Promise((resolve) => {
			check(resolve);
		});
	}

	@EventListener('click', Selectors.SearchBoxIcon)
	private _handleSearchClick() {
		// triggering submit on the form directly is not possible since it ignores query-parameter-name and result-url
		this.$ctx.find(Selectors.GSCSearchButton).click();
	}
}
